import React, { useState } from 'react';
import { Plus } from 'lucide-react';

const AddGameScheduleModal = ({ onClose, onAdd, leagues, seasons, onAddSeason }) => {
  const [gameData, setGameData] = useState({
    date: new Date().toISOString().split('T')[0],
    time: '18:00',
    opponent: '',
    location: '',
    league: leagues[0],
    seasonId: seasons && seasons.length > 0 ? seasons[0]?.id : '',
    notes: '',
    isHome: true
  });
  
  const [showAddSeason, setShowAddSeason] = useState(false);
  const [newSeasonData, setNewSeasonData] = useState({
    name: '',
    year: new Date().getFullYear().toString()
  });
  
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setGameData({
      ...gameData,
      [name]: type === 'checkbox' ? checked : value
    });
  };
  
  const handleSubmit = (e) => {
    e.preventDefault();
    onAdd(gameData);
  };
  
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-10">
      <div className="bg-white dark:bg-dark-200 rounded-lg p-4 w-11/12 max-w-md">
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-lg font-bold dark:text-darkText-primary">Add Game to Schedule</h3>
          <button onClick={onClose} className="text-gray-500 dark:text-gray-400">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
        
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-darkText-primary mb-1">Date</label>
            <input 
              type="date" 
              className="w-full p-2 border border-gray-300 dark:border-dark-400 dark:bg-dark-300 dark:text-darkText-primary rounded-md"
              name="date"
              value={gameData.date}
              onChange={handleChange}
              required
            />
          </div>
          
          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-darkText-primary mb-1">Time</label>
            <input 
              type="time" 
              className="w-full p-2 border border-gray-300 dark:border-dark-400 dark:bg-dark-300 dark:text-darkText-primary rounded-md"
              name="time"
              value={gameData.time}
              onChange={handleChange}
              required
            />
          </div>
          
          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-darkText-primary mb-1">Opponent</label>
            <input 
              type="text" 
              className="w-full p-2 border border-gray-300 dark:border-dark-400 dark:bg-dark-300 dark:text-darkText-primary rounded-md"
              placeholder="Team name"
              name="opponent"
              value={gameData.opponent}
              onChange={handleChange}
              required
            />
          </div>
          
          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-darkText-primary mb-1">Location</label>
            <input 
              type="text" 
              className="w-full p-2 border border-gray-300 dark:border-dark-400 dark:bg-dark-300 dark:text-darkText-primary rounded-md"
              placeholder="Field name or address"
              name="location"
              value={gameData.location}
              onChange={handleChange}
              required
            />
          </div>
          
          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-darkText-primary mb-1">League</label>
            <select 
              className="w-full p-2 border border-gray-300 dark:border-dark-400 dark:bg-dark-300 dark:text-darkText-primary rounded-md"
              name="league"
              value={gameData.league}
              onChange={handleChange}
            >
              {leagues.length > 0 ? (
                leagues.map((league, index) => (
                  <option key={index} value={league}>{league}</option>
                ))
              ) : (
                <option value="Default League">Default League</option>
              )}
            </select>
          </div>
          
          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-darkText-primary mb-1">Season</label>
            <div className="flex gap-2">
              <select 
                className="w-full p-2 border border-gray-300 dark:border-dark-400 dark:bg-dark-300 dark:text-darkText-primary rounded-md"
                name="seasonId"
                value={gameData.seasonId}
                onChange={handleChange}
              >
                <option value="">No Season</option>
                {seasons && seasons.length > 0 ? (
                  seasons.map((season) => (
                    <option key={season.id} value={season.id}>
                      {season.name} ({season.year})
                    </option>
                  ))
                ) : (
                  <option value="" disabled>No seasons available</option>
                )}
              </select>
              
              <button 
                type="button" 
                className="bg-gray-200 dark:bg-dark-400 text-gray-700 dark:text-darkText-primary p-2 rounded-md hover:bg-gray-300 dark:hover:bg-dark-300 flex items-center justify-center"
                onClick={() => setShowAddSeason(!showAddSeason)}
              >
                <Plus size={20} />
              </button>
            </div>
            
            {/* Add new season input */}
            {showAddSeason && (
              <div className="mt-2 p-3 border border-gray-200 dark:border-dark-400 rounded-md bg-gray-50 dark:bg-dark-300">
                <div className="text-sm font-medium mb-2 dark:text-darkText-primary">Add New Season</div>
                <div className="grid grid-cols-2 gap-2 mb-2">
                  <div>
                    <label className="block text-xs text-gray-600 dark:text-darkText-tertiary mb-1">Name</label>
                    <input
                      type="text"
                      className="w-full p-2 border border-gray-300 dark:border-dark-400 dark:bg-dark-300 dark:text-darkText-primary rounded-md text-sm"
                      placeholder="Season name"
                      value={newSeasonData.name}
                      onChange={(e) => setNewSeasonData({...newSeasonData, name: e.target.value})}
                    />
                  </div>
                  <div>
                    <label className="block text-xs text-gray-600 dark:text-darkText-tertiary mb-1">Year</label>
                    <input
                      type="text"
                      className="w-full p-2 border border-gray-300 dark:border-dark-400 dark:bg-dark-300 dark:text-darkText-primary rounded-md text-sm"
                      placeholder="Year"
                      value={newSeasonData.year}
                      onChange={(e) => setNewSeasonData({...newSeasonData, year: e.target.value})}
                    />
                  </div>
                </div>
                <button
                  type="button"
                  className="w-full bg-blue-600 dark:bg-blue-700 text-white py-1 px-3 rounded-md text-sm hover:bg-blue-700 dark:hover:bg-blue-600 transition-colors"
                  onClick={async () => {
                    if (newSeasonData.name && newSeasonData.year) {
                      try {
                        const seasonId = await onAddSeason({
                          name: newSeasonData.name,
                          year: newSeasonData.year
                        });
                        
                        if (seasonId) {
                          // Update the game data with the new season ID
                          setGameData({...gameData, seasonId});
                          // Reset the form and hide it
                          setNewSeasonData({
                            name: '',
                            year: new Date().getFullYear().toString()
                          });
                          setShowAddSeason(false);
                        }
                      } catch (error) {
                        console.error('Error adding season:', error);
                        alert('Failed to add season. Please try again.');
                      }
                    }
                  }}
                  disabled={!newSeasonData.name || !newSeasonData.year}
                >
                  Add Season
                </button>
              </div>
            )}
          </div>
          
          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-darkText-primary mb-1">Game Type</label>
            <div className="flex space-x-4">
              <label className="inline-flex items-center">
                <input 
                  type="radio" 
                  name="isHome" 
                  checked={gameData.isHome}
                  onChange={() => setGameData({...gameData, isHome: true})}
                  className="form-radio dark:bg-dark-300 dark:border-dark-400" 
                />
                <span className="ml-2 dark:text-darkText-primary">Home</span>
              </label>
              <label className="inline-flex items-center">
                <input 
                  type="radio" 
                  name="isHome" 
                  checked={!gameData.isHome}
                  onChange={() => setGameData({...gameData, isHome: false})}
                  className="form-radio dark:bg-dark-300 dark:border-dark-400" 
                />
                <span className="ml-2 dark:text-darkText-primary">Away</span>
              </label>
            </div>
          </div>
          
          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-darkText-primary mb-1">Notes</label>
            <textarea 
              className="w-full p-2 border border-gray-300 dark:border-dark-400 dark:bg-dark-300 dark:text-darkText-primary rounded-md h-20"
              placeholder="Additional information about the game"
              name="notes"
              value={gameData.notes}
              onChange={handleChange}
            ></textarea>
          </div>
          
          <div className="flex justify-end pt-2">
            <button 
              type="button"
              onClick={onClose}
              className="bg-gray-200 dark:bg-dark-400 text-gray-700 dark:text-darkText-primary mr-2 py-2 px-4 rounded hover:bg-gray-300 dark:hover:bg-dark-300"
            >
              Cancel
            </button>
            <button 
              type="submit" 
              className="bg-blue-600 dark:bg-blue-700 text-white py-2 px-4 rounded hover:bg-blue-700 dark:hover:bg-blue-600"
            >
              Add Game
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddGameScheduleModal;
